/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ speakers: NonNullable<unknown> }} Ccsl_Export_Speaker_OnlyInputs */



/**
* | output |
* | --- |
* | "{speakers}" |
*
* @param {Ccsl_Export_Speaker_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_speaker_only = /** @type {((inputs: Ccsl_Export_Speaker_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Speaker_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.speakers}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.speakers}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.speakers}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.speakers}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.speakers}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.speakers}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.speakers}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.speakers}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.speakers}`)
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
});